<template>
    <div class="form-group mt-3">
      <label v-if="label" :for="label" :class="labelClass">
        {{ label }} <span v-if="required">*</span>
      </label>

      <!-- Input text, number, email, date -->
      <b-form-input
        v-if="['text', 'number', 'email', 'date'].includes(type)"
        :type="type"
        :value="value"
        @input="$emit('input', $event)"
        :placeholder="placeholder"
        :required="required"
        :max="type === 'date' ? max : null"
        :disabled="disabled"
        :class="$attrs.class"
      />

      <!-- Textarea -->
      <b-form-textarea
        v-else-if="type === 'textarea'"
        :value="value"
        @input="$emit('input', $event)"
        :placeholder="placeholder"
        :rows="rows"
        :required="required"
        :class="$attrs.class"
      />

      <!-- Select -->
      <b-form-select
        v-else-if="type === 'select'"
        :value="value"
        @input="$emit('input', $event)"
        :options="options"
        :required="required"
        :class="$attrs.class"
      />

      <!-- File input -->
      <div v-else-if="type === 'file'">
        <b-form-file
          :accept="accept"
          @change="handleFileChange"
          :class="$attrs.class"
        />
        <p style="font-size: 10px;">Maksimal {{ computedMaxSize }} MB</p>

        <!-- Preview -->
        <div v-if="previewFile" class="mt-2">
          <p class="mb-1">Preview Lama:</p>
          <template v-if="isPDF(previewFile)">
            <a :href="previewFile" target="_blank" class="d-flex align-items-center">
              <b-img
                :src="require('@/assets/images/icon/icon-pdf.png')"
                alt="PDF"
                style="max-width: 100px;"
              />
              <span class="ml-2">Klik untuk membuka file PDF</span>
            </a>
          </template>
          <template v-else>
            <b-img
              :src="previewFile"
              fluid
              alt="Preview Lama"
              style="max-width: 200px; max-height: 200px; object-fit: contain;"
            />
          </template>
        </div>
      </div>

      <!-- Image input -->
      <div v-else-if="type === 'image'">
        <b-form-file
          accept="image/*"
          @change="handleFileChange"
        />
        <p style="font-size: 10px;">Maksimal {{ computedMaxSize }} MB (gambar)</p>

        <!-- Preview -->
        <div v-if="previewFile" class="mt-2">
          <p class="mb-1">Preview Gambar:</p>
          <b-img
            :src="previewFile"
            fluid
            alt="Preview Gambar"
            style="max-width: 200px; max-height: 200px; object-fit: contain;"
          />
        </div>
      </div>

      <!-- Input tanda pengenal -->
      <div v-else-if="type === 'tanda_pengenal'">
        <b-form-input
          type="date"
          :value="dateValue"
          @input="$emit('update:dateValue', $event)"
          :placeholder="placeholder"
          :required="required"
          :disabled="lifetimeValue"
          :max="max"
        />
        <b-form-checkbox
          :checked="lifetimeValue"
          class="mt-2"
          @change="handleSeumurHidup"
        >
          Berlaku Seumur Hidup
        </b-form-checkbox>
      </div>
    </div>
  </template>

  <script>
  export default {
    inheritAttrs: false,
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      labelClass: [String, Object, Array],
      type: {
        type: String,
        required: true
      },
      label: String,
      value: [String, Number, File],
      dateValue: String,
      lifetimeValue: Boolean,
      placeholder: String,
      options: {
        type: Array,
        default: () => []
      },
      accept: {
        type: String,
        default: 'application/pdf'
      },
      required: {
        type: Boolean,
        default: false
      },
      rows: {
        type: Number,
        default: 3
      },
      max: String,
      disabled: {
        type: Boolean,
        default: false
      },
      previewFile: {
        type: String,
        default: ''
      },
      maxSize: {
        type: Number,
        default: null // jika null, akan pakai default dari computed
      }
    },
    computed: {
      computedMaxSize() {
        if (this.maxSize) return this.maxSize;
        return this.type === 'image' ? 5 : 10; // default
      }
    },
    methods: {
      isPDF(url) {
        return typeof url === 'string' &&
          (url.toLowerCase().includes('.pdf') || url.startsWith('data:application/pdf'));
      },
      handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        // validasi tipe file
        if (!(file.type.startsWith('image/') || file.type === 'application/pdf')) {
          alert('File harus berupa gambar atau PDF.');
          e.target.value = null;
          return;
        }

        // validasi ukuran
        if (file.size > this.computedMaxSize * 1024 * 1024) {
          alert(`${this.label || 'File'} melebihi batas ${this.computedMaxSize}MB`);
          e.target.value = null;
          return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
          const base64 = event.target.result;
          this.$emit('input', base64);
        };
        reader.readAsDataURL(file);
      },
      handleSeumurHidup(checked) {
        this.$emit('update:lifetimeValue', checked);
        if (checked) {
          this.$emit('update:dateValue', null);
        }
      }
    }
  };
  </script>


// WEBPACK FOOTER //
// src/components/pengajuan-saya/FormInput.vue